import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
// @ts-ignore
import classNames from "classnames";
// @ts-ignore
import { Link as ScrollLink } from "react-scroll";

const Wrapper = styled.div`
  & .year-selector {
    align-items: center;
    display: flex;
    flex-direction: row;
  }

  & .toggle-btn {
    font-size: 2.625rem;

    &:after {
      border-top: 0.2em solid transparent;
      border-bottom: 0.2em solid transparent;
      border-left-width: 0.4em;
      border-left-style: solid;
      content: " ";
      display: inline-block;
      margin: 0.2em;
    }
  }

  & .year-selector__toggle {
    align-self: flex-start;
    cursor: pointer;
    flex: 1 0 auto;
  }

  & .year-selector__years-grid {
    flex: 1 0 auto;
    display: none;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 0.43rem;
    column-gap: 2%;
    text-align: center;
  }

  & .year-grid__item {
    cursor: pointer;
    font-size: 1.625rem;
  }

  & .tier-selector {
    align-items: center;
    display: none;
    flex-direction: row;

    & .tier-selector__toggle {
      flex: 1 0 auto;
    }

    & .tier-selector__tiers {
      display: flex;
      flex: 1 0 auto;
      font-size: 1.625rem;

      & span {
        flex: 1 0 auto;
      }
    }
  }

  &.is-year-selector-open {
    & .year-selector__years-grid {
      display: grid;
    }
  }

  &.is-tier-selector-open {
    & .year-selector {
      display: none;
    }

    & .tier-selector {
      display: flex;
    }
  }
`;

interface Props {
  yearSelected: number | null;
  setYearSelected: React.Dispatch<React.SetStateAction<number | null>>;
}

const YearSelector = ({ yearSelected, setYearSelected }: Props) => {
  const { t } = useTranslation();
  const years = [
    2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011,
  ];
  const tiers = [1, 2, 3];

  const [isYearSelectorOpen, setIsYearSelectorOpen] = useState(false);

  const [isTierSelectorOpen, setIsTierSelectorOpen] = useState(false);

  return (
    <Wrapper
      className={classNames(
        { "is-year-selector-open": isYearSelectorOpen && !isTierSelectorOpen },
        { "is-tier-selector-open": !isYearSelectorOpen && isTierSelectorOpen }
      )}
    >
      <div className="year-selector">
        <div
          className="year-selector__toggle toggle-btn"
          onClick={() => setIsYearSelectorOpen(!isYearSelectorOpen)}
        >
          {t("rankingsAndLevels.year")}
        </div>
        <div className="year-selector__years-grid">
          {years.map((year) => {
            return (
              <div
                key={year}
                className="year-grid__item"
                onClick={() => {
                  setYearSelected(year);
                  setIsYearSelectorOpen(false);
                  setIsTierSelectorOpen(true);
                }}
              >
                {year}
              </div>
            );
          })}
        </div>
      </div>
      <div className="tier-selector">
        <div
          className="tier-selector__toggle toggle-btn"
          onClick={() => {
            setYearSelected(null);
            setIsTierSelectorOpen(false);
            setIsYearSelectorOpen(true);
          }}
        >
          {yearSelected}
        </div>
        <div className="tier-selector__tiers">
          {tiers.map((tier) => (
            <ScrollLink
              key={`tier-${tier}`}
              className="index-scroll"
              to={`tier-${tier}-barchart`}
              spy={true}
              smooth={true}
              offset={-70}
              duration={500}
            >
              <span>Tier {tier}</span>
            </ScrollLink>
          ))}
        </div>
      </div>
    </Wrapper>
  );
};

export default YearSelector;
